module.exports = __webpack_public_path__ + "static/media/busFront.b791d45b.svg";